<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="消息模板名称/创建人/修改人搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-allow="'actAdd'"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditFormDialog', { type: 'add' })"
            >
              <b-icon-plus></b-icon-plus>新增
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
          <el-form-item label="消息模板名称">
            <el-input
              v-model.trim="form.msgTemplateName"
              placeholder="请输入消息模板名称"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="消息模板类型">
            <el-select
              v-model="form.msgTemplateType"
              placeholder="请选择消息模板类型"
              clearable
              style="width:100%"
              size="small"
            >
              <el-option label="短信" value="SMS" />
              <el-option label="邮件" value="mail" />
              <el-option label="微信推送" value="wechat" />
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="界面控件类型">
            <el-select
              v-model="form.controlType"
              placeholder="请选择界面控件类型"
              clearable
              size="small"
              style="width:100%"
            >
              <el-option label="文本框" value="input" />
              <el-option label="富文本" value="html" />
            </el-select>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="修改人名字">
            <el-input
              v-model.trim="form.modifyByName"
              placeholder="请输入修改人名字"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="创建人名字">
            <el-input
              v-model.trim="form.createByName"
              placeholder="请输入创建人名字"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="创建时间">
            <el-col :span="11">
              <el-date-picker
                v-model="form.createBeginDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="请选择创建时间"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="form.createEndDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="请选择创建时间"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="修改时间">
            <el-col :span="11">
              <el-date-picker
                v-model="form.modifyBeginDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="请选择修改时间"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="form.modifyEndDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="请选择修改时间"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="模板状态">
            <el-checkbox-group v-model="form.msgTemplateStatusList">
              <el-checkbox label="Y">已启用</el-checkbox>
              <el-checkbox label="N">未启用</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  msgTemplateStatusList: ['Y']
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm }
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
